import {reduxName} from './constants'

export const START_ZOOM: string = reduxName + '/START_ZOOM';
export const FINISH_ZOOM: string = reduxName + '/FINISH_ZOOM';
export const START_ROTATING: string = reduxName + '/START_ROTATING';
export const FINISH_ROTATING: string = reduxName + '/FINISH_ROTATING';
export const SET_ROTATION_ANGLE: string = reduxName + '/SET_ROTATION_ANGLE';